import React from 'react';
import Skill from './Skill';

const elements = [
  { name: "nodejs", src: require('../images/logos/nodejs.png')},
  { name: "mongodb", src: require('../images/logos/mongodb.png')},
  { name: "reactjs", src: require('../images/logos/react.png')},
  { name: "swift", src: require('../images/logos/swift.png')},
  { name: "kotlin", src: require('../images/logos/kotlin.png')},
  { name: "aws", src: require('../images/logos/aws.png')},
];




const skills = [];
for (const [index, value] of elements.entries()) {
  skills.push(
    <Skill
      key={index}
      name={value.name}
      src={value.src}
    />
  );
}

const Skills =  () => {

  return (
    <div className={"p-40px-tb border-top-1 border-bottom-1 border-color-gray"}>
      <div className={"container"}>
        <div
          className={"owl-carousel"}
          data-items={`${skills.length}`}
          data-nav-dots={"false"}
          data-md-items="6"
          data-sm-items="5"
          data-xs-items="4"
          data-xx-items="3"
          data-space="40"
          data-autoplay="true"
        >
          {skills}
        </div>
      </div>
    </div>
  );
}

export default Skills;
